import script from "./dashboard-overview-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard-overview-details.vue?vue&type=script&setup=true&lang=ts"

import "./dashboard-overview-details.vue?vue&type=style&index=0&id=32b8301a&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b8301a"]])

export default __exports__